import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { Home, Key, Star } from 'lucide-react';
export const Services = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].services;
  const icons = [<Home key="home" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-243" />, <Key key="key" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-244" />, <Star key="star" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-245" />];
  return <FadeInSection id="services" className="w-full bg-[#1a1a1a] py-24 lg:py-32" data-id="element-246">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-247">
        <div className="flex flex-col items-center text-center mb-20" data-id="element-248">
          <span className="eyebrow mb-4" data-id="element-249">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-white" data-id="element-250">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-251">
          {t.cards.map((card, index) => <div key={index} className="group relative bg-[#2a2a2a] p-10 lg:p-12 transition-all duration-500 hover:-translate-y-2" data-id="element-252">
              {/* Hover Border Effect */}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c9a96e] scale-y-0 origin-bottom group-hover:scale-y-100 transition-transform duration-500 ease-out" data-id="element-253" />

              {icons[index]}

              <h3 className="font-serif-display text-2xl text-white mb-4" data-id="element-254">
                {card.title}
              </h3>

              <p className="body-text text-gray-400 text-sm md:text-base" data-id="element-255">
                {card.desc}
              </p>
            </div>)}
        </div>
      </div>
    </FadeInSection>;
};